<!--
 * @Author: cn1994
 * @Date: 2023-08-23 10:11:23
 * @LastEditors: cn1994
 * @LastEditTime: 2023-10-13 15:40:35
 * @Description: 预览图顶部机构信息组件
-->
<template>
  <div class="ls-inst-info-component">
    <div class="avatar-wrap">
      <img :src="instInfo.instLogo">
    </div>
    <div class="title-wrap">
      <span class="title ellipsis-1">{{ instInfo.instTitle }}</span>
      <div class="subject-cell">
        <span class="subject">{{ instInfo.subject }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    instInfo: {
      type: Object,
    },
  },
}
</script>

<style lang="less" scoped>
.ls-inst-info-component {
  display: flex;
  flex-direction: row;
  padding-left: 30px;
  .avatar-wrap {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .title-wrap {
    display: flex;
    flex-direction: column;
    margin-left: 6px;
    .title {
      max-width: 100px;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      line-height: 20px;
      text-shadow: 0px 2px 8px rgba(0,0,0,0.4);
    }
    .subject-cell {
      background-color: rgba(255, 255, 255, 0.50);
      height: 24px;
      box-shadow: inset 0px 0px 7px 2px rgba(255,255,255,0.5);
      border-radius: 17px;
      padding: 0 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 6px;
      width: fit-content;
      .subject {
        font-size: 12px;
        color: #333;
        line-height: 17px;
      }
      .icon {
        color: #1890ff;
        font-size: 20px;
      }
    }
  }
}
</style>